<div class="container">
  <div class="alert-filter-container">
    <app-alert-settings-filter-panel
      (onAlertTypeChange)="onAlertTypeChange($event)"
      [alertCompanyData]="alertCompanyData"
      (selectCompany)="selectCompany($event)"
      (onDeleteClicked)="deleteAlerts(false)"
      (onAddAlert)="addAlert()"
      [(selectedRows)]="selectedRows"
    ></app-alert-settings-filter-panel>
  </div>
  <div class="alert-grid-container">
    <app-alert-settings-grid-wrapper
      (selectedRowsChange)="selectedRowsChange($event)"
      (alertCompanyDataSet)="alertCompanyDataSet($event)"
      [(selectedTab)]="selectedTab"
      [(selectedCompany)]="selectedCompany"
      (onDeleteClicked)="deleteAlerts($event)"
    ></app-alert-settings-grid-wrapper>
  </div>
</div>
